export const environment = {
  production: true,
  fullstoryOrgId: "o-1VYDK0-na1",
  fullStoryEnvironments: ["prexat", "xat", "prod"],
  baseHref: "",
  nexenTokenUrl: "/wove/api/nexenToken",
  woveTokenUrl: "/wove/api/wove-token",
  defaultDashboard: "home",
  devXATPath: "",
  appSettings: {
    rtnEndpoint: "wss://apigatewayws.qa.bnymellon.com/px-rtn/v1/ws",
    ngPaths: {
      thirdparty_url: "https://qa-www.pllcfiles.inautix.com/staticartifacts/thirdparty/",
      domain_url: "https://xat-pershingx.bnymellon.com",
      cdn_url: "https://qa-www.pllcfiles.inautix.com/staticartifacts/",
      pershing_url: "https://qa-www.pllcfiles.inautix.com/staticartifacts/@pershing/",
      ot_script_id: "972a418a-e12d-4959-a643-a443aca375c7-test",
      ot_url: "https://cdn.cookielaw.org",
      ot_sdk_js: "scripttemplates/otSDKStub.js",
      portal_userguide_url:
        "https://confluence.bnymellon.net/download/attachments/1171591904/Pershing%20X%20Platform%20MVP%20User%20Guide%20V1%20.docx?api=v2",
    },
    firmId: "CTIW",
    region: "qa",
    platform: "professional",
  },
  appConfig: {
    b2cAuthUrl:
      "https://wovepreprod.b2clogin.com/wovepreprod.onmicrosoft.com/b2c_1a_wri_signin_usernameoremail_mfa_wove/oauth2/v2.0/authorize?response_type=code&scope=openid&client_id=631de45f-0030-42e2-8107-8d30760ed3f&response_mode=fragment&&nonce=TIME&redirect_uri=https://xat-app-woveplatform.bnymellon.com/b2c-login",
    environment: "qa",
    nexenDomain: "https://apigatewaypx.qa.bnymellon.com/",
    qprURL: "/qa-edc-docsearch-svc-xat-service/edc/docsearchsvc/getDocumentsForSummaryWB",
    rtnEndpoint: "wss://apigatewayws.qa.bnymellon.com/px-rtn/v1/ws",
    woveRegion: "xat",
    wriKeepaliveUrl: "",
    whiteLabel: {
      firm: "",
      firmId: "",
      "--ds-color-primary-hue": "0",
      "--ds-color-primary-sat": "0",
      "--ds-color-primary-lit": "0",
    },
    rtnAuthEndpoint: "https://apigatewaypx.qa.bnymellon.com/px-rtn-rest/v1/auth-token",
    wriLogoutUrl: "",
    cdnBaseURL: "https://xat-www.pllcfiles.inautix.com/",
    defaultFirmConfig: {
      firmId: "default",
      termsOfUse: "/px-portal/terms-of-use",
      privacyPolicy: "https://www.pershing.com/us/en/data-privacy.html",
      cookiePolicy: "/px-portal/cookiePolicy",
      assetProtectionPolicy:
        "https://www.pershing.com/content/dam/pershing/documents/pdfs/understanding-the-protection-of-client-assets.pdf",
      marginDisclosure: "https://xat-netxinvestor.bnymellon.com/nxi/disclosure/brokeragedisclosure/margin",
    },
    portalConfigsList: {
      investor2FirmIds: [],
      financialPlanning: null,
      roleToUrlMap: {
        INVP: {
          DASF: {
            WRI: "home",
            MA_WRI: "home",
            MA: "home",
          },
          AAD: {
            WRI: "home/bob",
            MA_WRI: "home",
            MA: "home",
          },
        },
        PXSA: {
          DASF: {
            INTRNL: "admincenter",
          },
          AAD: {
            INTRNL: "admincenter",
            WRI: "home/bob",
            MA_WRI: "home",
          },
        },
        PXOA: {
          DASF: {
            INTRNL: "admincenter",
          },
          AAD: {
            INTRNL: "admincenter",
            WRI: "home/bob",
            MA_WRI: "home",
          },
        },
        PXPA: {
          DASF: {
            INTRNL: "admincenter",
          },
          AAD: {
            INTRNL: "admincenter",
            WRI: "home/bob",
            MA_WRI: "home",
          },
        },
        PXGA: {
          DASF: {
            INTRNL: "admincenter",
          },
          AAD: {
            INTRNL: "admincenter",
            WRI: "home/bob",
            MA_WRI: "home",
          },
        },
        INVS: {
          AAD: {
            WRI: "investor",
            MA_WRI: "investor",
            MA: "investor",
          },
          DASF: {
            WRI: "investor",
            MA_WRI: "investor",
            MA: "investor",
          },
        },
        EUSR: {
          DASF: {
            MA: "home",
            MA_WRI: "home",
          },
          AAD: {
            WRI: "home/bob",
            MA_WRI: "home",
          },
        },
        AMGR: {
          DASF: {
            MA: "trading/overview",
            MA_WRI: "trading/overview",
          },
          AAD: {
            WRI: "trading/overview",
            MA_WRI: "trading/overview",
          },
        },
      },

      featureFlags: {
        demoReadyTabsOnly: false,
        appUsage: false,
        rtn: false,
        overviewAdvisorSelect: true,
        messages: true,
        autoLaunchOverview: true,
        advisorLeftNav: true,
        dasfTokenViaApi: false,
        cacheInterceptor: true,
        wriNewRedirect: true,
        iframeLoginEnabled: false,
        iframeInitiateSsoEnabled: false,
        tosEnabled: false,
        unifiedLogin: false,
      },
      pershingUrls: [
        "downloadcenter",
        "docsearch",
        "docretrieve",
        "docviewer/servlet/Redirector",
        "icealert-nxi-services",
        "banking",
        "ecmsrestservice",
        "edelivery",
        "edeliverywove",
        "nds-balances",
        "nds-userbasics",
        "nds-groups",
        "nds-netxgroups",
        "nds-utilities",
        "nds-netxaccount",
        "rmds",
      ],
      apiUrls: [
        "apigateway",
        "/px-alert-api",
        "/px-party",
        "/px-data",
        "/pxsalesforce",
        "/px-trading-dashboard/api",
        "/proposal-svc",
        "/px-billing/rest/",
        "/port-construction-svc",
        "/invres-analytics-svc",
        "/alternatives",
        "/riskprofile-svc",
      ],
      pershingAppSettings: {
        agGridEnterpriseKey:
          "CompanyName=SHI International Corp_on_behalf_of_Pershing LLC,LicensedGroup=PERSHING-AG-GRID,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=65,LicensedProductionInstancesCount=5,AssetReference=AG-017559,ExpiryDate=28_July_2022_[v2]_MTY1ODk2MjgwMDAwMA==3733e30adc6e71242b1dea0b6f4ae6c7",
        cdnAttributes: {
          artifacts: {
            "@pershing/ees-opportunities": "9.1.12-SNAPSHOT",
            "@pershing/ees-search": "9.10.4-SNAPSHOT",
            "@pershing/netx-ng-groups": "1.8.21",
            "@pershing/netxwealth-branding": "24.1120.1",
            "@pershing/nxp-activity": "12.0.4-SNAPSHOT",
            "@pershing/nxp-aum": "5.5.1",
            "@pershing/nxp-balances": "12.14.0-SNAPSHOT",
            "@pershing/nxp-common-components": "14.2.4",
            "@pershing/nxp-f2": "2.2.0",
            "@pershing/nxp-fisellbid": "1.5.0",
            "@pershing/nxp-gainloss": "7.19.7-SNAPSHOT",
            "@pershing/nxp-notes": "2025.1.1-SNAPSHOT",
            "@pershing/nxp-workbook-common": "14.13.0-SNAPSHOT",
            "@pershing/nxp-workbook-orderstatus": "8.7.13-SNAPSHOT",
            "@pershing/pershing-common": "14.9.1",
            "@pershing/pershing-export": "14.9.1",
            "@pershing/pershing-grid2": "14.9.1",
            "@pershing/trading-alternative-investment-app": "2025.1.10",
            "@pershing/trading-common": "2025.1.10",
            "@pershing/trading-equity-app": "2025.1.10",
            "@pershing/trading-equity-order-import-app": "2025.1.10",
            "@pershing/trading-fixedincome-app": "2025.1.10",
            "@pershing/trading-mutualfund-app": "2025.1.10",
            "@pershing/trading-mutualfund-order-import-app": "2025.1.10",
            "@pershing/trading-options-app": "2025.1.10",
          },
          cdnPath: "https://xat-www.pllcfiles.inautix.com/staticartifacts",
          cdnSeparator: "@",
        },
        domainUrl: "https://xat-www2.netx360.inautix.com",
        platform: "professional",
        platformType: "wealth",
        region: "qa",
        routeStrategy: "service-discovery",
        space: "xat",
        theme: "compact",
      },
      personaSelectionConfig: {},
      sessionTimeoutProperties: {
        keepAliveInterval: 60 * 15,
        secondsBeforeIdle: 60 * 55,
        secondsBeforeTimeout: 60 * 5,
      },
      thirdPartyCookieUrl: "",
    },
  },
};
